export default "__VITE_ASSET__BrgCgD8p__"